import { render, staticRenderFns } from "./Terminals.vue?vue&type=template&id=97bab47c&scoped=true"
import script from "./Terminals.vue?vue&type=script&lang=js"
export * from "./Terminals.vue?vue&type=script&lang=js"
import style0 from "./Terminals.vue?vue&type=style&index=0&id=97bab47c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bab47c",
  null
  
)

export default component.exports